import React from 'react';

export default function Experience() {
  const stats = [
    {
      number: "350+",
      title: "Successful Worldwide Projects.",
      description: "Crafting impactful solutions across borders with proven project wins."
    },
    {
      number: "120+",
      title: "Happy Clients and Counting.",
      description: "Empowering brands with dedication, transparency, lasting relationships."
    },
    {
      number: "12+",
      title: "Sectors Served With Innovation.",
      description: "Shaping diverse industries through insight, creativity and strategy."
    }
  ];

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .branding-section {
          background-color: #f8f8f8;
          padding: 100px 0;
        }

        .container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 40px;
        }

        .top-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 80px;
          gap: 60px;
        }

        .main-heading {
          flex: 1;
          font-size: 3.5rem;
          font-weight: 700;
          line-height: 1.2;
          color: #1a1a1a;
        }

        .experience-badge-wrapper {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          gap: 40px;
        }

        .experience-badge {
          width: 280px;
          height: 280px;
          background-color: #E91E63;
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          position: relative;
        }

        .badge-number {
          font-size: 5rem;
          font-weight: 700;
          line-height: 1;
          margin-bottom: 10px;
        }

        .badge-text {
          font-size: 1.1rem;
          font-weight: 400;
          letter-spacing: 0.5px;
        }

        .experience-description {
          flex: 1;
          max-width: 400px;
        }

        .experience-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 15px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .experience-text {
          font-size: 16px;
          color: #999999;
          line-height: 1.7;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 60px;
        }

        .stat-item {
          position: relative;
          padding-left: 20px;
        }

        .stat-item::before {
          content: '';
          position: absolute;
          left: 0;
          top: 8px;
          width: 8px;
          height: 8px;
          background-color: #1a1a1a;
          border-radius: 50%;
        }

        .stat-number {
          font-size: 2.5rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 15px;
          display: block;
        }

        .stat-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 12px;
          line-height: 1.3;
        }

        .stat-description {
          font-size: 15px;
          color: #999999;
          line-height: 1.7;
        }

        @media (max-width: 1200px) {
          .top-row {
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 60px;
          }

          .experience-badge-wrapper {
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
          }

          .main-heading {
            font-size: 2.5rem;
            color: black;
          }

          .experience-badge {
            width: 220px;
            height: 220px;
          }

          .badge-number {
            font-size: 4rem;
          }

          .badge-text {
            font-size: 1rem;
          }
        }

        @media (max-width: 968px) {
          .stats-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .main-heading {
            font-size: 2rem;
          }
        }
      `}</style>

      <section className="branding-section">
        <div className="container">
          {/* Top Section */}
          <div className="top-row">
            <h2 className="main-heading text-dark">
              Designing<br />
              Intelligence<br />
              Into Every Detail.
            </h2>
            
            <div className="experience-badge-wrapper">
              <div className="experience-badge">
                <span className="badge-number">7+</span>
                <span className="badge-text">Years of Experience</span>
              </div>
              
              <div className="experience-description">
                <h3 className="experience-title">7+ Years of expertise</h3>
                <p className="experience-text">
                  Foxtroit fuses creativity with intelligence, building models that think, adapt, and evolve, driving focused growth in an ever-changing digital world.

                </p>
              </div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="stats-grid text-dark">
            {stats.map((stat, index) => (
              <div className="stat-item text-dark" key={index}>
                <span className="stat-number text-dark">{stat.number}</span>
                <h3 className="stat-title text-dark">{stat.title}</h3>
                <p className="stat-description text-dark">{stat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}